import api from '@/utils/api';

/**
 * delete quote module
 *
 * @param {string} companyId - The company id
 * @param {string} id - The quote module id
 * @returns {Promise} The promise object of the api call
 */
const deleteCompanyQuoteModuleApi = (companyId, id) =>
  api.delete(`company/${companyId}/quote-module/${id}`);

export default deleteCompanyQuoteModuleApi;
